import {CLEANING_WIZARD_STATE} from '@/constants/enums';
import {DEVICE_STATE} from '@/constants/pcConstAppData';

const convertCleaningStatusToDisplayString = (status) => {
  switch (status) {
    case DEVICE_STATE.DIAFILTRATE:
      return CLEANING_WIZARD_STATE.BUFFER_EXCHANGE;
    case DEVICE_STATE.REVERSE_CONCENTRATE:
      return CLEANING_WIZARD_STATE.AIR_RECOVERY;
    default:
      return status;
  }
};

export default convertCleaningStatusToDisplayString;
